var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.subheaderClasses,attrs:{"id":"kt_subheader"}})
}
var staticRenderFns = []

export { render, staticRenderFns }